import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { GithubConnector } from '../../connector';

export const GithubService = IntegrationService.make({
  connector: GithubConnector,
  name: Integration_Service_Names_Enum.Github,
});
